/** QuickPlan — Fixations posables à la main (outil « Fixation ») : vis, clous, boulons…
 *
 * Convention commune : origine = point de la SURFACE, +Z local = vers l'extérieur
 * (côté tête) ; la tige s'enfonce vers -Z sur la longueur L. L'outil oriente +Z selon
 * la normale de la face cliquée et attache la fixation à la pièce (elle la suit).
 */

const fix = (id, name, color, params, parts, ref, price, description) => ({
  id, name, category: 'quincaillerie', family: 'Fixations', color, params, parts,
  ports: [{ id: 'surface', pos: [0, 0, 0], dir: [0, 0, 1] }],
  bom: { kind: 'piece', label: ref, price },
  description: `${description} Origine sur la surface, tête vers +Z, tige vers -Z.`,
});

const D = (def, options) => ({ key: 'D', label: 'Diamètre', default: def, options, unit: 'mm' });
const L = (def, min, max) => ({ key: 'L', label: 'Longueur', default: def, min, max, unit: 'mm' });

export default [
  fix('qc-vis', 'Vis', '#d9b44a', [D(4, [2.5, 3, 3.5, 4, 4.5, 5, 6, 8]), L(30, 6, 200)], [
    { type: 'cyl', name: 'tête', r: 'D', h: 'D*0.6', pos: [0, 0, 0] },
    { type: 'cyl', name: 'tige', r: 'D/2', h: 'L', pos: [0, 0, '-L'] },
  ], 'Ø{D}×{L}', 0.08, 'Vis à bois / aggloméré.'),
  fix('qc-clou', 'Clou / pointe', '#9aa0a6', [D(2, [1.2, 1.6, 2, 2.5, 3, 4]), L(40, 10, 150)], [
    { type: 'cyl', name: 'tête', r: 'D*1.2', h: 'D*0.4', pos: [0, 0, 0] },
    { type: 'cyl', name: 'tige', r: 'D/2', h: 'L', pos: [0, 0, '-L'] },
  ], 'Ø{D}×{L}', 0.02, 'Clou ou pointe.'),
  fix('qc-boulon', 'Boulon + écrou', '#7a8088', [D(8, [4, 5, 6, 8, 10, 12]), L(40, 10, 200)], [
    { type: 'cyl', name: 'tête', r: 'D*0.9', h: 'D*0.7', pos: [0, 0, 0] },
    { type: 'cyl', name: 'tige', r: 'D/2', h: 'L', pos: [0, 0, '-L'] },
    { type: 'cyl', name: 'écrou', r: 'D*0.9', h: 'D*0.8', pos: [0, 0, '-L+D*0.2'] },
  ], 'M{D}×{L}', 0.3, 'Boulon à tête hexagonale avec écrou en bout de tige.'),
  fix('qc-cheville', 'Cheville', '#e6e6e6', [D(8, [5, 6, 8, 10, 12]), L(40, 20, 120)], [
    { type: 'cyl', name: 'collerette', r: 'D*0.75', h: 1.5, pos: [0, 0, 0] },
    { type: 'cyl', name: 'corps', r: 'D/2', h: 'L', pos: [0, 0, '-L'] },
  ], 'Ø{D}×{L}', 0.1, 'Cheville nylon (mur, béton).'),
  fix('qc-tourillon', 'Tourillon', '#c8a46a', [D(8, [6, 8, 10]), L(30, 20, 60)], [
    { type: 'cyl', name: 'corps', r: 'D/2', h: 'L', pos: [0, 0, '-L/2'] },
  ], 'Ø{D}×{L}', 0.03, 'Tourillon bois (à moitié dans chaque pièce).'),
  fix('qc-rivet', 'Rivet aveugle', '#b0b0b0', [D(4, [3, 4, 5]), L(10, 4, 30)], [
    { type: 'cyl', name: 'tête', r: 'D', h: 1.2, pos: [0, 0, 0] },
    { type: 'cyl', name: 'corps', r: 'D/2', h: 'L', pos: [0, 0, '-L'] },
  ], 'Ø{D}×{L}', 0.05, 'Rivet aveugle aluminium.'),
  {
    id: 'qc-equerre-meuble',
    name: 'Équerre de fixation',
    category: 'quincaillerie',
    family: 'Fixations',
    description: 'Petite équerre acier L 40×40×16, coin à l\'origine, ailes le long de +X et +Z. Emplacements : 2 vis par aile.',
    color: '#9aa0a6',
    parts: [
      { type: 'box', size: [40, 16, 2], pos: [0, -8, 0] },
      { type: 'box', size: [2, 16, 40], pos: [0, -8, 0] },
    ],
    ports: [{ id: 'coin', pos: [0, 0, 0] }],
    fixings: [
      { type: 'vis', d: 4, l: 16, pos: ['14+i*16', 0, 2], dir: [0, 0, 1], repeat: { count: 2, var: 'i' } },
      { type: 'vis', d: 4, l: 16, pos: [2, 0, '14+i*16'], dir: [1, 0, 0], repeat: { count: 2, var: 'i' } },
    ],
    bom: { kind: 'piece', price: 0.6 },
  },
];
